exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-091b0f3d]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;height:100vh;background:#ff847b;color:white}.icon[data-v-091b0f3d]{font-size:45px;margin:5px}.link[data-v-091b0f3d]{text-decoration:underline;cursor:pointer}.row[data-v-091b0f3d]{-ms-flex-pack:center;justify-content:center;text-align:center}div[data-v-091b0f3d]{text-align:center;line-height:25px}div>*[data-v-091b0f3d]{width:100%}\n", ""]);

// exports
